import Vue from "vue";
import { mapState, mapGetters } from "vuex";

const globalMaster = {
  install(Vue, options) {
    Vue.mixin({
      computed: {
        ...mapState({
          visitStatus: (state) => state.visit.visitStatus,
        }),

        ...mapGetters({
          newAccessToken: ["auth/getAccessToken"],
        }),

        setheaders() {
          return {
            Authorization: this.newAccessToken,
            "Content-Type": "application/json",
          };
        },
      },
      methods: {
        displayVisitDetail(object) {
          const data = object;
          const results = {
            customerID: data.customer_id,
            visitID: data.visit_id,
            customerName: data.customer_name,
            customerPicture: data.customer_pic,
            typeName: data.type,
            distance: data.distance,
            todoList: data.todo_list,
            status: parseInt(data.status),
            statusName: data.status_name,
            dateVisit: data.date_visit,
            dateVisitEN: data.date_visit_format,
            dateStatus: data.date_status,
            checkInDate: data.checkIn_date,
            checkInTime: data.checkIn_time,
            checkOutDate: data.checkOut_date,
            checkOutTime: data.checkOut_time,
            checkTime: data.checkTime,
            note: data.note,
            planbyName: data.planby_name,
            planBy: data.plan_by,
            backgroundColor: this.visitStatus[parseInt(data.status)]
              .backgroundColor,
            textColor: this.visitStatus[parseInt(data.status)].textColor,
            borderColor: this.visitStatus[parseInt(data.status)].borderColor,
          };
          return results;
        },

        // sortted
        sortedNumber(table, param) {
          const data = table;
          this.orderBy[param] = !this.orderBy[param];
          const check = this.orderBy[param];
          this.table = check
            ? data.sort((a, b) => Number(a[param]) - Number(b[param]))
            : data.sort((a, b) => Number(b[param]) - Number(a[param]));
        },

        sortedString(table, param) {
          const data = table;
          this.orderBy[param] = !this.orderBy[param];
          const check = this.orderBy[param];
          this.table = check
            ? data.sort((a, b) => b[param].localeCompare(a[param]))
            : data.sort((a, b) => a[param].localeCompare(b[param]));
        },
      },
    });
  },
};

Vue.use(globalMaster);

export default {};
